module.exports = __webpack_public_path__ + "static/media/abdul.1c5c79ca.jpg";